import { SocialMediaIntegrationBannerController } from './social-media-integration-banner.controller'

function socialMediaIntegrationBanner () {
  return {
    restrict: 'E',
    controller: SocialMediaIntegrationBannerController,
    templateUrl: '/arts/directives/social-media-integration-banner/social-media-integration-banner.html?$$REVISION$$'
  }
}

export { socialMediaIntegrationBanner }
